<script>
  import { technologieLogos, toolLogos } from "../json/logos";

  export let className = "horizontal";
</script>

<main class={className}>
  {#if className === "horizontal"}
    <img class="batuhan-jpg" src="bm-smile.jpg" alt="batuhan" width="300" />
  {/if}

  <div class="info">
    {#if className === "vertical"}
      <img class="batuhan-jpg" src="batuhan.jpg" alt="batuhan" width="300" />
    {/if}
    <h1>BATUHAN MÜNGER</h1>
    <h3>Frontend Developer</h3>

    <p>Technologies I use:</p>
    {#each technologieLogos as { id, name, src } (id)}
      <img class="logo" {src} alt="{name}-logo" height="40" />
    {/each}

    <p>Tools I use:</p>
    {#each toolLogos as { id, name, src } (id)}
      <img class="logo" {src} alt="{name}-logo" height="40" />
    {/each}
  </div>
</main>

<style>
  main {
    padding: 1em;
    display: flex;
    justify-content: center;
  }

  .horizontal {
    flex-direction: row;
  }

  .vertical {
    text-align: center;
  }

  .batuhan-jpg {
    border-radius: 50%;
    width: 300px;
  }

  .info {
    margin-left: 2em;
  }
  .info > h1 {
    margin-bottom: 0;
  }
  .info > h3 {
    margin-top: 0;
    color: var(--secondColor);
  }

  .logo {
    height: 40px;
    margin-right: 5px;
  }

  @media (max-width: 992px) {
    .horizontal,
    .vertical {
      flex-direction: column;
      text-align: center;
      border-radius: 50%;
      align-items: center;
      margin: 0;
      padding: 0;
    }

    .info {
      margin-left: 0;
    }

    main {
      justify-content: center;
    }

    .batuhan-jpg {
      max-width: 300px;
    }
  }
</style>
